/* 
  故障工单 
 */
<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/worksheet_mn/FaultOrder_mn' }">故障记录</el-breadcrumb-item>
            <el-breadcrumb-item>{{vin}}</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 状态 -->
        <div class="operation_list">
            <el-row :gutter="24" style="padding-top: 10px;">
                <el-col :span="14">
                    <el-card class="boxs">
                        <el-row :gutter="24" style="margin-top: -10px;">
                            <el-col :span="8">
                                <div class="text item">
                                    车辆编号：<span class="txt">{{ carData.vin }}</span>
                                </div>
                                <div class="text item">
                                    车&nbsp;&nbsp;牌&nbsp;&nbsp;号：<span class="txt">{{
                                    carData.car_number
                                    }}</span>
                                </div>
                                <div class="text item">
                                    车辆型号：<span class="txt">{{ carData.name }}</span>
                                </div>
                                <div class="text item">
                                    车辆类型：<span class="txt">{{ carData.code }}</span>
                                </div>
                                <div class="text item">
                                    当前位置：
                                    <p class="txt"
                                        style="width: 80%; margin-top: -20px; margin-left: 70px;margin-bottom: -20px;">
                                        {{ gps }}
                                    </p>
                                </div>
                                <div class="text item">
                                    所属区域：<span class="txt">{{ carData.group }}</span>
                                </div>
                                <div class="text item">
                                    数据时间：<span class="txt">{{
                                    carData.last_upload_data_time
                                    }}</span>
                                </div>
                                <div class="text item">
                                    运行状态：<span class="txt">{{ carData.runStatus }}</span>
                                </div>
                                <div class="text item">
                                    急停状态：<span class="txt">{{ carData.stop_status }}</span>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="text item">
                                    当前电压：<span class="txt">{{ carData.current_total_voltage }}V</span>
                                </div>
                                <div class="text item">
                                    当前电流：<span class="txt">{{ carData.current_total_current }}A</span>
                                </div>
                                <div class="text item">
                                    车辆速度：<span class="txt">{{ carData.car_speed }}Km/h</span>
                                </div>
                                <div class="text item">
                                    电机转速：<span class="txt">{{ carData.motor_speed }}r</span>
                                </div>
                                <div class="text item">
                                    驾驶模式：<span class="txt">自动</span>
                                </div>
                                <div class="text item">
                                    电机扭矩：<span class="txt">{{ carData.motor_speed }}km</span>
                                </div>
                                <div class="text item">
                                    控制器温度：<span class="txt">{{ carData.motor_controller_temperature }}°C</span>
                                </div>
                                <div class="text item">
                                    电机温度：<span class="txt">{{ carData.drive_motor_temperature }}°C</span>
                                </div>
                                <div class="text item">
                                    当前挡位：<span class="txt">{{ carData.gear }}</span>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="text item">
                                    母线电流：<span class="txt">{{ carData.motor_controller_bus_current }}A</span>
                                </div>
                                <div class="text item">
                                    母线电压：<span class="txt">{{ carData.motor_controller_input_voltage }}V</span>
                                </div>
                                <div class="text item">
                                    转向角度：<span class="txt">{{ carData.current_angle }}°</span>
                                </div>
                                <div class="text item">
                                    EPS温度：<span class="txt">{{ carData.steering_motor_temperature }}°C</span>
                                </div>
                                <div class="text item">
                                    EPS电流：<span class="txt">{{ carData.steering_motor_current }}A</span>
                                </div>
                                <div class="text item">
                                    累计里程：<span class="txt">{{ carData.total_mileage }}Km</span>
                                </div>
                                <div class="text item">
                                    制动状态：<span class="txt">{{
                                    carData.braking_state
                                    }}</span>
                                </div>
                                <div class="text item">
                                    剩余电量：<span class="txt">{{ carData.electricity }}%</span>
                                </div>
                                <div class="text item">
                                    充电状态：<span class="txt">{{
                                    carData.charging_status
                                    }}</span>
                                </div>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-col>
                <el-col :span="10">
                    <el-card class="boxs">
                        <el-timeline :reverse="reverse" style="height: 360px; overflow-y: auto">
                            <el-button class="btnDis" style="width:80px" size="small" round @click="faultDis()">详 情
                            </el-button>
                            <el-timeline-item placement="top" type="primary " v-for="(item, index) in historyData"
                                :key="index" :timestamp="item.fault_time">
                                {{ item.equipment_name }}:{{ item.fault_details }}
                            </el-timeline-item>
                        </el-timeline>
                    </el-card>

                </el-col>
            </el-row>
            <el-row :gutter="24" style="padding-top: 10px;">
                <el-col :span="9">
                    <el-card class="box" v-loading="fault">
                        <div class="falutbox">
                            <div id="myChartOne"></div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="15">
                    <el-card class="box" v-loading="payNum">
                        <div class="falut-gbox">
                            <div id="myChartTwo"></div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import {
    get_detail_list,
    get_fault_number_by_vin,
    get_fault_his_by_vin,
} from "../../api/faultStatistics/faultStatistics";
import Chart from "echarts";
let myChartOne = null;
let myChartTwo = null;
export default {
    data() {
        return {
            input: "",
            vin: window.localStorage.getItem("fault_vin"),
            carData: {},
            reverse: false,
            fault: true,
            payNum: true,
            gps: "",
            historyData: [],
            seriesData: [],
            carNumber_name: [],
            carNumber_value: [],
            tableData: [
                {
                    id: 1,
                    vin: "asdf123456",
                    faultySystem: "控制系统",
                    faultyDetails: "阿斯顿发文",
                    faultyType: "刹车",
                    faultyTime: "2022-10-05 10:55:36",
                    faultyStatus: "未处理",
                    faultyDescribe: "且吃饭改水电费"
                },
                {
                    id: 2,
                    vin: "asdf123456",
                    faultySystem: "控制系统",
                    faultyDetails: "阿斯顿发文",
                    faultyType: "刹车",
                    faultyTime: "2022-10-05 10:55:36",
                    faultyStatus: "已处理",
                    faultyDescribe: "且吃饭改水电费"
                }
            ],
            timer: null,
        };
    },
    created() {
        window.localStorage.removeItem("faultName");
        this.timer = setInterval(() => {
            this.getdata();
            this.getFaultHis();
            this.getFault();
            this.getCarNumber();
        }, 1000)
    },
    mounted() {
        this.getpayNum();
        this.getClick();
    },
    updated() {
        setTimeout(() => {
            //设置延迟执行
            this.myChartOne.setOption({
                series: [
                    {
                        name: "故障分类",
                        type: "pie",
                        radius: "50%",
                        data: this.seriesData,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            });
            this.myChartTwo.setOption({
                xAxis: {
                    type: "category",
                    data: this.carNumber_name,
                    axisLine: {
                        lineStyle: {
                            color: "#999999",
                            width: 1,
                        },
                    },
                    axisLabel: {
                        margin: 10,
                        height: 80,
                        interval: 0,
                        textStyle: {
                            fontSize: 10,
                            color: "#999999",
                        },
                    },
                },
                series: [
                    {
                        name: "故障/数量",
                        type: "bar",
                        barGap: 0,
                        data: this.carNumber_value,
                        barWidth: 10,
                        itemStyle: {
                            color: "#48cefd",
                        },
                    },
                ],
            });
        }, 500);
    },
    destroyed() {
        clearInterval(this.timer)
    },
    methods: {
        //待处理列表
        getdata() {
            get_detail_list(this.vin).then((res) => {
                if (res["code"] === 0) {
                    this.carData = res.data;
                    if (res.data.gps.longitude === 0 && res.data.gps.latitude === 0) {
                        this.gps = "山东省淄博市临淄区金岭回族镇舜泰汽车有限公司";
                    } else {
                        this.getAddressData(res.data.gps);
                    }
                }
            })
        },
        //坐标
        getAddressData(gps) {
            let that = this;
            AMap.plugin("AMap.Geocoder", function () {
                var geocoder = new AMap.Geocoder({
                    city: "010", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                });
                var lnglat = [];
                var _lnglat = [];
                lnglat.push(gps.longitude);
                lnglat.push(gps.latitude);
                AMap.convertFrom(lnglat, that.carData.gps_code, function (status, result) {
                    if (result.info === 'ok') {
                        var resLnglat = result.locations[0];
                        _lnglat.push(resLnglat.lng);
                        _lnglat.push(resLnglat.lat);
                        geocoder.getAddress(_lnglat, function (status, result) {
                            if (status === "complete" && result.regeocode) {
                                var address = result.regeocode.formattedAddress;
                                that.gps = address;
                            }
                        });
                    }
                });

            });
        },
        getFaultHis() {
            get_fault_his_by_vin(this.vin).then((res) => {
                if (res["code"] === 0) {
                    this.historyData = res.data
                }
            })
        },
        faultDis() {
            this.$router.push("/worksheet_mn/faultHistory");
        },
        // 支付方式统计
        getFault() {
            get_fault_number_by_vin(this.vin).then((res) => {
                if (res["code"] === 0) {
                    this.seriesData = res.data;
                    if (this.seriesData) {
                        this.fault = false
                    }
                }
            });
        },
        getpayNum() {
            var that = this
            var myChart = document.getElementById("myChartOne");
            this.myChartOne = Chart.init(myChart);
            var option;
            option = {
                title: {
                    text: "故障分类",
                    left: 500,
                    top: 0,
                    textStyle: {
                        fontSize: 12,
                        color: "#999",
                    },
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b} : {c} ({d}%)",
                },
                legend: {
                    orient: "vertical",
                    left: "left",
                },
                series: [
                    {
                        name: "故障分类",
                        type: "pie",
                        radius: "50%",
                        data: this.seriesData,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 20,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            };
            this.myChartOne.on('click', function (params) {
                window.localStorage.setItem("faultName", params.name);
                that.$router.push("/worksheet_mn/faultType_mn");
            });
            option && this.myChartOne.setOption(option);
        },
        getCarNumber() {
            var name = []
            var value = []
            get_fault_number_by_vin(this.vin).then((res) => {
                if (res["code"] === 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        name.push(res.data[i].name);
                        value.push(res.data[i].value);
                    }
                    this.carNumber_name = name
                    this.carNumber_value = value
                    if (this.carNumber_name && this.carNumber_value) {
                        this.payNum = false
                    }
                }
            });
        },
        getClick() {
            var that = this
            var myChart2 = document.getElementById("myChartTwo");
            this.myChartTwo = Chart.init(myChart2);
            var Clickoption;
            (Clickoption = {
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    data: [
                        {
                            name: "故障/数量",
                            icon: "rect",
                        },
                    ],
                    top: 1,
                    left: 1,
                    itemGap: 10,
                    itemWidth: 12,
                    itemHeight: 12,
                    textStyle: {
                        fontSize: 12,
                        color: "#323232",
                    },
                },
                grid: {
                    left: 50,
                    right: 10,
                    top: 30,
                    bottom: 20,
                    borderWidth: 1,
                },
                xAxis: {
                    type: "category",
                    data: this.carNumber_name,
                    axisLine: {
                        lineStyle: {
                            color: "#999999",
                            width: 1,
                        },
                    },
                    axisLabel: {
                        margin: 10,
                        height: 80,
                        interval: 0,
                        textStyle: {
                            fontSize: 10,
                            color: "#999999",
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            color: "#999999",
                            width: 1,
                        },
                    },
                    axisLabel: {
                        margin: 14,
                        textStyle: {
                            fontSize: 10,
                            color: "#999999",
                        },
                    },
                },
                series: [
                    {
                        name: "型号/数量",
                        type: "bar",
                        barGap: 0,
                        data: this.carNumber_value,
                        barWidth: 10,
                        itemStyle: {
                            color: "#48cefd",
                        },
                    },
                ],
            })
            this.myChartTwo.on('click', function (params) {
                console.log(params.name);
                window.localStorage.setItem("faultName", params.name);
                that.$router.push("/worksheet_mn/faultType_mn");
            });
            Clickoption && this.myChartTwo.setOption(Clickoption);
        },
    },
};
</script>

<style>
.operation_list {
    width: 100%;
}

.box {
    width: 100%;
    height: 360px;
}

.boxs {
    width: 100%;
    height: 400px;
}

.text {
    font-size: 14px;
    color: #999;
}

.item {
    margin-top: 20px;
    margin-left: 15px;
}

.txt {
    color: #000;
}

.btnDis {
    position: absolute;
    right: 80px;
    z-index: 100;
}

.falutbox {
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
    border-radius: 5px;
    height: 310px;
}

#myChartOne {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
}

.falut-gbox {
    background-color: #fff;
    margin-top: 10px;
    border-radius: 5px;
    height: 310px;
    box-sizing: border-box;
    /* padding: 10px; */
}

#myChartTwo {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/worksheet_mn/faultStatistics.vue